export default __webpack_public_path__ + "static/884-f47861e23d7f8a8f58f975f0bc6e6c73.gif";